export default __webpack_public_path__ + "static/reviews-image-a640d36466f0870fec36210ba9274d10.png";